module.exports = __webpack_public_path__ + "img/RadixEyeGPT.713c349b.webp";